/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


// Speed-optimizer apps (e.g. AVADA lightJS) can suspend the theme's jQuery
// until first user interaction, so `$` must never be called at parse time:
// a top-level throw would kill everything below it in this file, including
// the vanilla-JS colour-sync and toast IIFEs. All top-level jQuery calls go
// through this gate instead.
function ozWhenJQueryReady(fn) {
  if (window.jQuery) { fn(window.jQuery); return; }
  var poll = setInterval(function () {
    if (window.jQuery) { clearInterval(poll); fn(window.jQuery); }
  }, 100);
}

//#endregion Cart

//#region Product Form
var productData = null;
const originalSelectorId = '#Variant';
var $productForm = null;
ozWhenJQueryReady(function ($) {
  productData = $("#ProductJson").html();
  $productForm = $('#AddToCartForm');
});
function getCurrentVariant() {
  return product_form.$data.current_variant;
};
function ProductFormOptions() {
  var currentVariant = getCurrentVariant();

  // set compare price
  localStorage.setItem(currentVariant.id, currentVariant.compare_at_price);

  updateSlider(currentVariant);

  $('[name="warranty"]').on("change", function() {
    updatePrice(getCurrentVariant());
  });
}
function UpdateSelectedVariant(variant) {
  updateHistoryState(variant);
  updateMasterSelect(variant);
  updatePrice(variant);
  updateStock(variant);
  updateCondition(variant);
  updateSlider(variant);

  // set compare price
  localStorage.setItem(variant.id, variant.compare_at_price);
}

/**
 * Updates the product price
 *
 * @param {Variant} variant - The new variant
 * @param {jQuery} $price - The product price container
 */
function updatePrice(variant) {
  if(variant.available) {
    $('#AddToCart').removeAttr('disabled');
    $('[data-atc-text]').text($('[data-atc-text]').data('atc-text'));
    $('[data-atc-text-sm]').text($('[data-atc-text-sm]').data('atc-text-sm'));
  } else {
    $('#AddToCart').attr('disabled', true);
    $('[data-atc-text]').text('Sold out');
    $('[data-atc-text-sm]').text('Sold out');
  }

  let additional_price = 0;

  if($('[name="warranty"]').length > 0) {
    let $warranty_option = $('[name="warranty"]:checked');
    additional_price += parseInt($warranty_option.data('warranty-price'));
  }

  var $price = $(selectors.price);
  var onSale = variant.price < variant.compare_at_price;
  // Update sale status
  if(onSale) {
    $($price).addClass('on_sale');
  } else {
    $($price).removeClass('on_sale');
  }
  
  // Update prices
  $(selectors.regular_price).html(formatMoney(variant.price + additional_price, "${{amount}}"));
  if(onSale) {
    $(selectors.sale_price).html(formatMoney(variant.compare_at_price + additional_price, "${{amount}}"));
  }
  $(selectors.zip_price).html(formatMoney(variant.price / 4, "${{amount}}"));
  $(selectors.afterpay_price).html(formatMoney(variant.price / 4, "${{amount}}"));
  $('[data-add-to-cart]').data('cart-price', variant.price + additional_price);
}

ozWhenJQueryReady(function ($) {
$('.main_content_warrenty label.warranty-option').click(function(){
    event.preventDefault();
    if($(this).find('input').is(':checked')){
        $(this).find('input').prop('checked', false)
        var pr = $('.product-checkout .form-row .col-auto .text-dark.tst strong').text().replace('$', '').replace(',', '')
        console.log(parseFloat(pr) - 59)
        // $('.product-checkout h3.text-dark.tst strong').html('$'+((parseFloat(pr) - 59).toFixed(2)).toLocaleString())
        // $('.col-auto h4.tstt').html('$'+((parseFloat(pr) - 59).toFixed(2)).toLocaleString())
        ProductFormOptions()
    }else{
         $(this).find('input').prop('checked', true)
        var pr = $('.product-checkout .form-row .col-auto .text-dark.tst strong').text().replace('$', '').replace(',', '')
        console.log(parseFloat(pr) + 59)
        console.log('js file')
        // $('.product-checkout h3.text-dark.tst strong').html('$'+((parseFloat(pr) + 59).toFixed(2)).toLocaleString())
        // $('.col-auto h4.tstt').html('$'+((parseFloat(pr) + 59).toFixed(2)).toLocaleString())
        ProductFormOptions()
    }
})
});


document.addEventListener("DOMContentLoaded", function() {
 document.addEventListener('change', function(e){
  	var el = e.target;

    if(el.classList.contains('related_product_block_check_input') || el.closest('.related_product_block_check_input')) {
      // OZ 2026-10-15: only the old checkbox cards (other templates) sit inside .related_product_block_check;
      // the new product page's switch rows do not, and threw here on every change.
      let parentEl = el.closest('.related_product_block_check');
      if (parentEl) parentEl.classList.toggle('checked', el.checked);

    }
  });

  var swatchWithImage = document.querySelector(".block-swatch__item-popout-image");
  var triangle = document.querySelector(".condition-premium-popup-triangle");
  if(swatchWithImage && triangle){
    var parentSwatch = swatchWithImage.closest(".block-swatch");

    if(parentSwatch){
     var position = parentSwatch.offsetLeft + (parentSwatch.getBoundingClientRect().width / 2 - 19);
     triangle.style.left =  position + "px";
     triangle.style.opacity = 1;
    }
  }
  window.addEventListener('resize', function(e){
   var swatchWithImage = document.querySelector(".block-swatch__item-popout-image");
  var triangle = document.querySelector(".condition-premium-popup-triangle");
  if(swatchWithImage && triangle){
    var parentSwatch = swatchWithImage.closest(".block-swatch");

    if(parentSwatch){
     var position = parentSwatch.offsetLeft + (parentSwatch.getBoundingClientRect().width / 2 - 19);
     triangle.style.left =  position + "px";
    }
  }
  });

});

// =========================================================
// IMAGE → VARIANT SYNC
// When a gallery image/thumbnail is selected, updates the
// matching colour swatch so the selected variant always
// reflects the visible image. Prevents the mismatch where
// a customer sees Pink but is ordering Black.
//
// Uses Shopify's built-in variant→image assignments from
// product JSON (variant.featured_media.id). No ALT text required.
//
// When the current condition is unavailable in the clicked colour,
// automatically selects the nearest available condition (preferring
// one step up for upsell). Ranking: Good < Excellent < Ex-Demo
// < Exceptional < New. Handles both gallery thumbnail clicks
// (via syncVariantFromThumbnail) and colour swatch clicks (via
// variant:changed post-correction). Fires oz:image-colour-sync
// event so the toast system can show an accurate message.
// =========================================================
(function () {
  'use strict';

  var _productDataCache = null;
  var _mediaColourMap = null;
  // assets/oz-high-variants.js rewrites the product JSON once it has the variants past 250.
  document.addEventListener('oz:product-json-updated', function () {
    _productDataCache = null;
    _mediaColourMap = null;
  });
  var _isPageLoadSync = false; // suppress toast during initial gallery sync
  var _capturedCondition = null; // condition value captured before theme can modify it
  var _preClickCondition = null; // condition before colour swatch click (for post-correction)
  var _preClickStorage = null;   // storage before colour swatch click (for toast reporting)
  var _isPostCorrecting = false; // prevent infinite loop in post-correction

  // Higher number = better condition
  var CONDITION_RANK = { 'Good': 1, 'Excellent': 2, 'Ex-Demo': 3, 'Exceptional': 4, 'New': 5 };

  // Find best available condition: try UP first (upsell), only go DOWN if nothing above.
  // Within a direction, pick the closest. Returns condition string or null.
  function findNearestCondition(pool, condPos, currentCondition) {
    if (!currentCondition) return null;
    var currentRank = CONDITION_RANK[currentCondition] || 0;
    var aboveBest = null, aboveDist = Infinity;
    var belowBest = null, belowDist = Infinity;
    pool.forEach(function (v) {
      var cond = v['option' + condPos];
      var rank = CONDITION_RANK[cond] || 0;
      if (rank === currentRank) return; // skip same condition
      if (rank > currentRank) {
        var d = rank - currentRank;
        if (d < aboveDist) { aboveDist = d; aboveBest = cond; }
      } else {
        var d = currentRank - rank;
        if (d < belowDist) { belowDist = d; belowBest = cond; }
      }
    });
    return aboveBest || belowBest;
  }

  function getProductData() {
    if (_productDataCache) return _productDataCache;
    var el = document.querySelector('[data-product-json]');
    if (!el) return null;
    try {
      _productDataCache = JSON.parse(el.textContent || el.innerHTML);
      return _productDataCache;
    } catch (e) { return null; }
  }

  function normalise(s) { return s.toLowerCase().replace('colour', 'color'); }

  function buildMediaColourMap() {
    if (_mediaColourMap) return _mediaColourMap;
    var data = getProductData();
    var variants = (data && data.product && data.product.variants) || (data && data.variants);
    if (!data || !data.options_with_values || !variants) { return (_mediaColourMap = {}); }

    var optionPos = null;
    data.options_with_values.forEach(function (opt) {
      if (normalise(opt.name) === 'color') { optionPos = opt.position; }
    });
    if (!optionPos) return (_mediaColourMap = {});

    var map = {};
    variants.forEach(function (variant) {
      if (variant.featured_media && variant.featured_media.id) {
        var colourValue = variant['option' + optionPos];
        if (colourValue) { map[String(variant.featured_media.id)] = colourValue.toLowerCase(); }
      }
    });
    return (_mediaColourMap = map);
  }

  function getColourFromThumb(thumb) {
    var mediaId = thumb.getAttribute('data-media-id');
    if (!mediaId) return null;
    return buildMediaColourMap()[mediaId] || null;
  }

  function radioSelector(pos, suffix) {
    return ['.color-swatch__radio', '.variant-swatch__radio', '.block-swatch__radio', '.product-form__single-selector']
      .map(function (cls) { return cls + '[data-option-position="' + pos + '"]' + (suffix || ''); }).join(',');
  }

  function clickRadio(pos, value, withMousedown) {
    document.querySelectorAll(radioSelector(pos)).forEach(function (radio) {
      if (radio.value.toLowerCase() === value.toLowerCase() && !radio.checked) {
        if (withMousedown) {
          var label = radio.id ? document.querySelector('label[for="' + radio.id + '"]') : null;
          if (label) { label.dispatchEvent(new MouseEvent('mousedown', { bubbles: true, cancelable: true })); }
        }
        radio.click();
      }
    });
  }

  function syncVariantFromThumbnail(thumb) {
    var colourValue = getColourFromThumb(thumb);
    if (!colourValue) return;

    var data = getProductData();
    if (!data || !data.options_with_values) return;

    var variants = (data.product && data.product.variants) || data.variants;
    if (!variants) return;

    var colourPos = null, conditionPos = null, storagePos = null;
    data.options_with_values.forEach(function (opt) {
      if (normalise(opt.name) === 'color') { colourPos = opt.position; }
      if (opt.name === 'Condition') { conditionPos = opt.position; }
      if (opt.name === 'Storage') { storagePos = opt.position; }
    });
    if (!colourPos) return;

    // smart-watches: a photo selects its colour and nothing else. Size and
    // condition stay as the customer set them, in stock or not (no upsell jump, unlike phones).
    // Keep in step with the template list in theme.js (_onOptionChanged) and oz-colour-list.js.
    var OZ_NO_AUTO_CHANGE_TEMPLATES = ['smart-watches'];
    if (OZ_NO_AUTO_CHANGE_TEMPLATES.indexOf(data.template) !== -1) {
      _capturedCondition = null;
      clickRadio(colourPos, colourValue, true);
      return;
    }

    // Use condition captured at capture phase (before theme's Flickity handler
    // can change it). Falls back to reading the radio for non-thumbnail triggers.
    var currentCondition = null;
    if (conditionPos) {
      if (_capturedCondition) {
        currentCondition = _capturedCondition;
        _capturedCondition = null;
      } else {
        var checkedCond = document.querySelector(radioSelector(conditionPos, ':checked'));
        if (checkedCond) { currentCondition = checkedCond.value; }
      }
    }

    // Read current storage
    var currentStorage = null;
    if (storagePos) {
      var checkedStorage = document.querySelector(radioSelector(storagePos, ':checked'));
      if (checkedStorage) { currentStorage = checkedStorage.value; }
    }

    // All available variants for the target colour
    var availableForColour = variants.filter(function (v) {
      return v.available &&
        v['option' + colourPos] &&
        v['option' + colourPos].toLowerCase() === colourValue;
    });

    // Colour entirely OOS — still switch to it (shows "Sold out"), skip condition logic
    if (!availableForColour.length) {
      clickRadio(colourPos, colourValue, true);
      return;
    }

    // Narrow to current storage first; if nothing available, find nearest storage
    var targetStorage = currentStorage;
    var pool = availableForColour;
    if (storagePos && currentStorage) {
      var inCurrentStorage = availableForColour.filter(function (v) {
        return v['option' + storagePos] === currentStorage;
      });
      if (inCurrentStorage.length) {
        pool = inCurrentStorage;
      } else {
        // Build storage order from DOM radio buttons
        var storageOrder = [];
        document.querySelectorAll(radioSelector(storagePos)).forEach(function (r) {
          if (storageOrder.indexOf(r.value) === -1) storageOrder.push(r.value);
        });
        var currentIdx = storageOrder.indexOf(currentStorage);
        // Find nearest storage tier, prefer one step up (upsell) at equal distance
        var bestDist = Infinity, bestIdx = -1;
        availableForColour.forEach(function (v) {
          var s = v['option' + storagePos];
          var idx = storageOrder.indexOf(s);
          var d = Math.abs(idx - currentIdx);
          if (d < bestDist || (d === bestDist && idx > bestIdx)) {
            bestDist = d;
            bestIdx = idx;
            targetStorage = s;
          }
        });
        pool = availableForColour.filter(function (v) {
          return v['option' + storagePos] === targetStorage;
        });
      }
    }

    // Target condition: keep current if available in pool, otherwise find nearest (up first)
    var targetCondition = null;
    if (conditionPos && currentCondition) {
      var currentOk = pool.some(function (v) {
        return v['option' + conditionPos] === currentCondition;
      });
      if (currentOk) {
        targetCondition = currentCondition;
      } else {
        targetCondition = findNearestCondition(pool, conditionPos, currentCondition);
      }
    }

    var needsStorageChange = storagePos && targetStorage && targetStorage !== currentStorage;
    var needsConditionChange = conditionPos && targetCondition && targetCondition !== currentCondition;

    if (needsStorageChange || needsConditionChange) {
      // Click changed options silently (no mousedown = no toast from toast IIFE)
      if (needsStorageChange) { clickRadio(storagePos, targetStorage, false); }
      if (needsConditionChange) { clickRadio(conditionPos, targetCondition, false); }

      // Yield to event loop, then dispatch sync event and click colour
      setTimeout(function () {
        if (!_isPageLoadSync) {
          document.dispatchEvent(new CustomEvent('oz:image-colour-sync', {
            detail: {
              colour: colourValue,
              fromCondition: currentCondition,
              toCondition: targetCondition || currentCondition,
              fromStorage: currentStorage,
              toStorage: targetStorage || currentStorage
            }
          }));
        }
        clickRadio(colourPos, colourValue, true);
      }, 0);
    } else {
      clickRadio(colourPos, colourValue, true);
    }
  }

  // On page load, scroll gallery to match the selected variant's image.
  // Fixes mismatch where gallery shows image #1 but a different colour is pre-selected.
  function syncGalleryOnLoad(thumbnailList) {
    var data = getProductData();
    if (!data || !data.options_with_values) return;

    var variants = (data.product && data.product.variants) || data.variants;
    if (!variants || !data.selected_variant_id) return;

    var selectedVariant = null;
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].id === data.selected_variant_id) { selectedVariant = variants[i]; break; }
    }
    if (!selectedVariant || !selectedVariant.featured_media) return;

    var selectedMediaId = String(selectedVariant.featured_media.id);

    // If gallery is already showing the correct image, do nothing
    var activeThumb = thumbnailList.querySelector('.is-nav-selected[data-media-id]');
    if (activeThumb && activeThumb.getAttribute('data-media-id') === selectedMediaId) return;

    // Click the correct thumbnail to scroll gallery to it (suppress toast)
    var correctThumb = thumbnailList.querySelector('[data-media-id="' + selectedMediaId + '"]');
    if (correctThumb) {
      _isPageLoadSync = true;
      correctThumb.click();
      setTimeout(function () { _isPageLoadSync = false; }, 50);
    }
  }

  function init() {
    var thumbnailList = document.querySelector('.product-gallery__thumbnail-list');
    if (!thumbnailList) return;
    // Apple Watch listings run their own light gallery (assets/oz-watch-gallery.js).
    if (thumbnailList.hasAttribute('data-oz-watch-gallery')) return;
    buildMediaColourMap();

    // Detect the condition option position once
    var data = getProductData();
    var condPos = null;
    if (data && data.options_with_values) {
      data.options_with_values.forEach(function (opt) {
        if (opt.name === 'Condition') { condPos = opt.position; }
      });
    }

    // CAPTURE phase: save the user's selected condition BEFORE the theme's
    // Flickity handler can change it. The theme resolves a new variant when
    // the carousel image changes, overwriting condition radios with the first
    // matching variant (often an unavailable one like "Good"). By capturing
    // here, syncVariantFromThumbnail reads the user's actual selection.
    if (condPos) {
      thumbnailList.addEventListener('click', function (e) {
        var thumb = e.target.closest('[data-media-id]');
        if (!thumb) return;
        var checkedCond = document.querySelector(radioSelector(condPos, ':checked'));
        _capturedCondition = checkedCond ? checkedCond.value : null;
      }, true); // capture phase fires before theme handlers
    }

    thumbnailList.addEventListener('click', function (e) {
      var thumb = e.target.closest('[data-media-id]');
      if (thumb && !_isPageLoadSync) { syncVariantFromThumbnail(thumb); }
    });

    // A swipe on the photo itself selects that photo's colour too, exactly as tapping its thumbnail does
    // (OZ 2026-10-14). Until now only thumbnail taps synced, so a swiped-to photo could show one colour
    // while the form sold another; on phones the new product page hides the thumbnail strip, which left
    // swiping as the only way to change photos. Only gestures count: a slide change caused by a variant
    // change (colour picked, page load) is not a swipe and is left alone. The condition is captured at
    // the start of the gesture, as the thumbnail capture above does.
    var carousel = document.querySelector('.product-gallery__carousel');
    if (carousel) {
      var swipeArmed = false;
      var armTimer = null;
      var selectedMediaId = function () {
        var item = carousel.querySelector('.product-gallery__carousel-item.is-selected[data-media-id]');
        return item ? item.getAttribute('data-media-id') : null;
      };
      var lastMediaId = selectedMediaId();
      var arm = function () {
        swipeArmed = true;
        clearTimeout(armTimer);
        if (condPos) {
          var checkedCond = document.querySelector(radioSelector(condPos, ':checked'));
          _capturedCondition = checkedCond ? checkedCond.value : null;
        }
      };
      var disarmSoon = function () {
        clearTimeout(armTimer);
        armTimer = setTimeout(function () { swipeArmed = false; _capturedCondition = null; }, 700);
      };
      carousel.addEventListener('pointerdown', arm, true);
      carousel.addEventListener('touchstart', arm, { capture: true, passive: true });
      document.addEventListener('pointerup', function () { if (swipeArmed) disarmSoon(); }, true);
      document.addEventListener('touchend', function () { if (swipeArmed) disarmSoon(); }, { capture: true, passive: true });
      new MutationObserver(function () {
        var mediaId = selectedMediaId();
        if (!mediaId || mediaId === lastMediaId) return;
        lastMediaId = mediaId;
        if (!swipeArmed || _isPageLoadSync) return;
        swipeArmed = false;
        clearTimeout(armTimer);
        syncVariantFromThumbnail(carousel.querySelector('.product-gallery__carousel-item.is-selected[data-media-id]'));
      }).observe(carousel, { attributes: true, subtree: true, attributeFilter: ['class'] });
    }

    // Detect colour and storage option positions (alongside condPos above)
    var colourPos = null, storagePos = null;
    if (data && data.options_with_values) {
      data.options_with_values.forEach(function (opt) {
        if (normalise(opt.name) === 'color') { colourPos = opt.position; }
        if (opt.name === 'Storage') { storagePos = opt.position; }
      });
    }

    // ── Post-correction for colour swatch clicks ──
    // The theme's native variant resolution picks the FIRST available variant
    // for a clicked colour (often "Good", the lowest condition). Our thumbnail
    // handler catches gallery clicks, but colour swatch clicks go entirely
    // through the theme. This post-correction listener catches the theme's
    // wrong resolution and fixes it to the nearest available condition.
    if (condPos && colourPos) {
      // Save condition BEFORE colour swatch mousedown (capture phase)
      document.addEventListener('mousedown', function (e) {
        var label = e.target.closest('label[for]');
        if (!label) return;
        var radio = document.getElementById(label.getAttribute('for'));
        if (!radio) return;
        var pos = parseInt(radio.getAttribute('data-option-position'), 10);
        if (pos !== colourPos) return; // only colour swatch clicks
        var condRadio = document.querySelector(radioSelector(condPos, ':checked'));
        _preClickCondition = condRadio ? condRadio.value : null;
        _preClickStorage = storagePos ? (document.querySelector(radioSelector(storagePos, ':checked')) || {}).value || null : null;
        // Signal toast IIFE to suppress its own toast (post-correction will handle it)
        document._ozColourSwatchPending = !!_preClickCondition;
      }, true);

      // Post-correct after theme resolves wrong condition
      document.addEventListener('variant:changed', function (e) {
        if (_isPostCorrecting || _isPageLoadSync) return;
        var savedCond = _preClickCondition;
        var savedStorage = _preClickStorage;
        _preClickCondition = null;
        _preClickStorage = null;
        // Clear flag asynchronously so toast IIFE's handler (same event) still sees it
        setTimeout(function () { document._ozColourSwatchPending = false; }, 0);
        if (!savedCond) return;
        // No condition upsell on smart-watches (see syncVariantFromThumbnail).
        var templateData = getProductData();
        if (templateData && ['smart-watches'].indexOf(templateData.template) !== -1) return;

        var nv = e.detail.variant;
        if (!nv) return;

        var newCond = nv['option' + condPos];
        var newStorage = storagePos ? nv['option' + storagePos] : null;
        // Build storage detail for toast (theme may have changed storage too)
        var storageDetail = {};
        if (savedStorage && newStorage && savedStorage !== newStorage) {
          storageDetail = { fromStorage: savedStorage, toStorage: newStorage };
        }

        if (newCond === savedCond) {
          // Condition preserved; still show toast if storage changed
          if (storageDetail.fromStorage) {
            if (!_isPageLoadSync) {
              document.dispatchEvent(new CustomEvent('oz:image-colour-sync', {
                detail: Object.assign({ colour: (nv['option' + colourPos] || '').toLowerCase(), fromCondition: savedCond, toCondition: savedCond }, storageDetail)
              }));
            }
          }
          return;
        }

        var newColour = nv['option' + colourPos];
        if (!newColour) return;

        // Find available variants for this colour
        var pData = getProductData();
        var variants = (pData.product && pData.product.variants) || pData.variants;
        if (!variants) return;

        var availableForColour = variants.filter(function (v) {
          return v.available && v['option' + colourPos] === newColour;
        });
        if (!availableForColour.length) return;

        // Find nearest condition: try UP first (upsell), only DOWN if nothing above
        var bestCond = findNearestCondition(availableForColour, condPos, savedCond);
        if (!bestCond) return;

        if (bestCond !== newCond) {
          // Theme picked wrong condition. Post-correct to nearest.
          _isPostCorrecting = true;
          clickRadio(condPos, bestCond, false);
          setTimeout(function () {
            if (!_isPageLoadSync) {
              document.dispatchEvent(new CustomEvent('oz:image-colour-sync', {
                detail: Object.assign({ colour: newColour.toLowerCase(), fromCondition: savedCond, toCondition: bestCond }, storageDetail)
              }));
            }
            _isPostCorrecting = false;
          }, 0);
        } else if (newCond !== savedCond || storageDetail.fromStorage) {
          // Theme picked correct condition but still need toast (condition or storage changed)
          if (!_isPageLoadSync) {
            document.dispatchEvent(new CustomEvent('oz:image-colour-sync', {
              detail: Object.assign({ colour: newColour.toLowerCase(), fromCondition: savedCond, toCondition: newCond }, storageDetail)
            }));
          }
        }
      });
    }

    // Delay so Flickity carousel is initialized before we try to scroll it
    setTimeout(function () { syncGalleryOnLoad(thumbnailList); }, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();


// =========================================================
// VARIANT CHANGE NOTIFICATION TOAST
// Alerts customers when Condition or Colour silently changes
// due to auto-fallback variant selection logic.
// =========================================================
(function () {
  'use strict';

  var intentClickedPosition = null;
  var DISMISS_DELAY = 6000;
  var toastContainer = null;

  // Inject CSS
  (function injectStyles() {
    if (document.getElementById('oz-variant-toast-styles')) { return; }
    var style = document.createElement('style');
    style.id = 'oz-variant-toast-styles';
    style.textContent = [
      '#oz-variant-toast-container {',
      '  position: fixed;',
      '  top: 20px;',
      '  left: 50%;',
      '  transform: translateX(-50%);',
      '  z-index: 99999;',
      '  display: flex;',
      '  flex-direction: column;',
      '  align-items: center;',
      '  gap: 10px;',
      '  pointer-events: none;',
      '  width: max-content;',
      '  max-width: calc(100vw - 32px);',
      '}',
      '.oz-variant-toast {',
      '  background: rgba(28, 28, 30, 0.92);',
      '  backdrop-filter: blur(20px);',
      '  -webkit-backdrop-filter: blur(20px);',
      '  color: #fff;',
      '  padding: 12px 20px;',
      '  border-radius: 20px;',
      '  font-size: 14px;',
      '  line-height: 1.4;',
      '  max-width: 380px;',
      '  box-shadow: 0 8px 32px rgba(0,0,0,0.35);',
      '  display: flex;',
      '  align-items: center;',
      '  gap: 10px;',
      '  pointer-events: all;',
      '  transform: translateY(-80px);',
      '  opacity: 0;',
      '  transition: transform 0.45s cubic-bezier(0.34, 1.56, 0.64, 1), opacity 0.25s ease;',
      '}',
      '.oz-variant-toast.oz-toast--visible {',
      '  transform: translateY(0);',
      '  opacity: 1;',
      '}',
      '.oz-variant-toast.oz-toast--hiding {',
      '  transform: translateY(-80px);',
      '  opacity: 0;',
      '  transition: transform 0.3s ease, opacity 0.25s ease;',
      '}',
      '.oz-toast__icon { flex-shrink: 0; font-size: 16px; line-height: 1; }',
      '.oz-toast__body { flex: 1; }',
      '.oz-toast__close {',
      '  flex-shrink: 0; background: none; border: none;',
      '  color: rgba(255,255,255,0.5); font-size: 18px; line-height: 1;',
      '  cursor: pointer; padding: 0;',
      '}',
      '.oz-toast__close:hover { color: #fff; }',
      '@media (max-width: 480px) {',
      '  #oz-variant-toast-container { top: 16px; left: 16px; right: 16px; transform: none; width: auto; max-width: 100%; }',
      '  .oz-variant-toast { max-width: 100%; border-radius: 16px; }',
      '}'
    ].join('\n');
    document.head.appendChild(style);
  })();

  // Read option position -> name map from embedded product JSON
  function getOptionNames() {
    var jsonEl = document.querySelector('[data-product-json]');
    if (!jsonEl) { return null; }
    var data;
    try { data = JSON.parse(jsonEl.textContent || jsonEl.innerHTML); }
    catch (err) { return null; }
    var opts = data.options_with_values;
    if (!opts || !opts.length) { return null; }
    var map = {};
    opts.forEach(function (opt) { map[opt.position] = opt.name; });
    return map;
  }

  // Capture which option position user intentionally clicked (mousedown fires before radio changes)
  function attachMousedownCapture() {
    document.addEventListener('mousedown', function (e) {
      var label = e.target.closest(
        '.block-swatch__item, .color-swatch__item, .variant-swatch__item'
      );
      if (!label) { intentClickedPosition = null; return; }
      var radio = document.getElementById(label.getAttribute('for') || '');
      if (!radio) { intentClickedPosition = null; return; }
      var pos = parseInt(radio.getAttribute('data-option-position'), 10);
      intentClickedPosition = isNaN(pos) ? null : pos;
    }, true); // capture phase: fires before theme handlers
  }

  // Compare old and new variant; show toast if any option silently changed
  function attachVariantChangedListener() {
    document.addEventListener('variant:changed', function (e) {
      var newV = e.detail.variant;
      var prevV = e.detail.previousVariant;
      var clickedPos = intentClickedPosition;
      intentClickedPosition = null;

      // Skip when colour swatch post-correction will handle the toast
      if (document._ozColourSwatchPending) { return; }

      if (!newV || !prevV || clickedPos === null) { return; }

      var optionNames = getOptionNames();
      if (!optionNames) { return; }

      // Collect ALL positions where value changed silently (user did NOT click)
      var silentChanges = [];
      for (var i = 1; i <= 3; i++) {
        if (i === clickedPos) { continue; }
        if (prevV['option' + i] && newV['option' + i] &&
            prevV['option' + i] !== newV['option' + i]) {
          silentChanges.push(i);
        }
      }

      if (!silentChanges.length) { return; }

      var newIntent = newV['option' + clickedPos];

      // Build "switched to" summary: "Condition to Ex-Demo, Storage to 256GB"
      var switchParts = [];
      silentChanges.forEach(function (pos) {
        switchParts.push(optionNames[pos] + ' to ' + newV['option' + pos]);
      });

      // the option that had to change comes first (Dereck 2026-10-16): "Blue isn't available in Excellent", not the reverse
      var message = prevV['option' + silentChanges[0]] + ' isn\'t available in '
        + newIntent
        + '. Switched ' + switchParts.join(', ') + '.';

      showToast(message);
    });
  }

  function showToast(message) {
    if (!toastContainer) { return; }

    // Build DOM nodes safely (no innerHTML with dynamic content)
    var toast = document.createElement('div');
    toast.className = 'oz-variant-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');

    var icon = document.createElement('span');
    icon.className = 'oz-toast__icon';
    icon.setAttribute('aria-hidden', 'true');
    icon.textContent = '\u2139'; // Unicode info circle

    var body = document.createElement('span');
    body.className = 'oz-toast__body';
    body.textContent = message; // textContent is XSS-safe

    var close = document.createElement('button');
    close.className = 'oz-toast__close';
    close.setAttribute('aria-label', 'Dismiss');
    close.textContent = '\u00d7'; // multiplication sign (x)

    toast.appendChild(icon);
    toast.appendChild(body);
    toast.appendChild(close);

    close.addEventListener('click', function () { dismissToast(toast); });
    toastContainer.appendChild(toast);

    // Double rAF ensures transition plays (element must paint in hidden state first)
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        toast.classList.add('oz-toast--visible');
      });
    });

    var timer = setTimeout(function () { dismissToast(toast); }, DISMISS_DELAY);
    toast.addEventListener('mouseenter', function () { clearTimeout(timer); });
    toast.addEventListener('mouseleave', function () {
      timer = setTimeout(function () { dismissToast(toast); }, 2000);
    });
  }

  function dismissToast(toast) {
    toast.classList.remove('oz-toast--visible');
    toast.classList.add('oz-toast--hiding');
    toast.addEventListener('transitionend', function fn() {
      toast.removeEventListener('transitionend', fn);
      if (toast.parentNode) { toast.parentNode.removeChild(toast); }
    });
  }

  // Show accurate toast when image sync switches condition and/or storage
  function attachImageSyncListener() {
    document.addEventListener('oz:image-colour-sync', function (e) {
      var d = e.detail;
      var condChanged = d.fromCondition && d.toCondition && d.fromCondition !== d.toCondition;
      var storageChanged = d.fromStorage && d.toStorage && d.fromStorage !== d.toStorage;
      if (!condChanged && !storageChanged) { return; }

      var colour = d.colour.replace(/\b\w/g, function (c) { return c.toUpperCase(); });
      var switchParts = [];
      if (condChanged) { switchParts.push('Condition to ' + d.toCondition); }
      if (storageChanged) { switchParts.push('Storage to ' + d.toStorage); }

      showToast(colour + ' isn\'t available in ' + d.fromCondition
        + '. Switched ' + switchParts.join(', ') + '.');
    });
  }

  // Bootstrap - handles both sync and async/deferred script loading
  function bootstrap() {
    toastContainer = document.createElement('div');
    toastContainer.id = 'oz-variant-toast-container';
    document.body.appendChild(toastContainer);
    attachMousedownCapture();
    attachVariantChangedListener();
    attachImageSyncListener();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }

})();

/* ---------------------------------------------------------------------------
 * OZ 2026-10-09: the rewards line follows the selected variant
 *
 * snippets/product-rewards.liquid renders "Earn N reward points" for the
 * variant selected on page load, and nothing used to update it, so picking a
 * dearer condition or storage left the first variant's points on screen. This
 * redoes the Liquid sum on every variant change: the price through
 * money_without_currency with "," and "." removed, times 2. Under a
 * no-decimals money format that is the whole dollars; otherwise it is the
 * cents, so the result always matches what the page was rendered with.
 * ------------------------------------------------------------------------ */
(function () {
  function rewardPoints(cents) {
    var format = (window.theme && window.theme.moneyFormat) || '';
    var amount = /no_decimals/.test(format) ? Math.round(cents / 100) : cents;
    return amount * 2;
  }

  document.addEventListener('variant:changed', function (event) {
    var variant = event.detail && event.detail.variant;
    if (!variant || typeof variant.price !== 'number') return;

    // The nearest ancestor of the form that changed which holds a rewards line,
    // so a quick view or featured product never rewrites the main product's.
    var node = event.target;
    while (node && node !== document && !(node.querySelector && node.querySelector('.product-rewards__points'))) {
      node = node.parentNode;
    }
    var points = (node || document).querySelectorAll('.product-rewards__points');
    for (var i = 0; i < points.length; i++) {
      points[i].textContent = rewardPoints(variant.price);
    }
  });
})();


/* ---------------------------------------------------------------------------
 * OZ 2026-10-14 (new product page, slice A1): on phone-width product pages the
 * LiveChat greeting card (about 320 x 240) opened over the price and the buy
 * box. There it is put away as soon as it shows; the chat bubble stays, above
 * the sticky add to cart bar (assets/theme.css), and opens the chat as before.
 * Wider screens and every other page keep the greeting.
 * ------------------------------------------------------------------------ */
(function () {
  if (!document.body || !document.body.classList.contains('template-product')) return;
  if (!window.matchMedia || !window.matchMedia('(max-width: 999px)').matches) return;

  var tries = 0;
  (function bind() {
    var widget = window.LiveChatWidget;
    if (!widget || typeof widget.on !== 'function') {
      if (++tries < 40) setTimeout(bind, 250);
      return;
    }
    widget.on('greeting_displayed', function () {
      try { widget.call('hide_greeting'); } catch (e) {}
    });
  })();
})();
